import React, { Component } from 'react'
import { InputNumber, Input, Button } from 'antd'

export default class Step1 extends Component {

    render() {
        return (
            <>
                <h3 className='tx-blue font-weight-bold'>Adquira o seu FLWT!</h3>
                <div className='d-flex align-items-end mt-2 step1Token'>
                    <div className='w-50 pr-2'>
                        <label className='tx-pink font-weight-bold'>Quantos FLWT você quer comprar?</label>
                        <InputNumber className='formToken' onChange={this.props.onChange} type='number' min={1} max={1000-this.props.tokens} defaultValue={1} value={this.props.qt} />
                    </div>
                    <div className='totalToken d-flex flex-column justify-content-center align-items-center'>
                        <div className='w-100 d-flex justify-content-between'><span className='font-weight-bold'>Preço FLWT</span> <span>R$500,00</span></div>
                        <div className='d-flex justify-content-between w-100 mt-2'><span className='font-weight-bold tx-pink'>Total a pagar</span> <span>R${this.props.qt * 500},00</span></div>
                    </div>
                </div>
                <br />
                <label className='tx-pink font-weight-bold'>Seu endereço Solana</label>
                <Input className='formToken' value={this.props.enderecoSolana} onChange={this.props.onChangeSolana} type='text' />
                {this.props.error !== '' && <small style={{color: 'red'}}>{this.props.error}</small>}
                <center><Button onClick={this.props.onNextStep} className="btnGrafico mt-4">Continuar</Button></center>
            </> 
        )
    }
}